export default "__VITE_ASSET__DHbezxFX__"